import Message from '../models/Message'

const messages: Message[] = [
  { id: '1', date: 'Today', category: 'Care Reminder', subject: "It's almost time for your annual mammogram.", read: false },
  { id: '2', date: 'Yesterday', category: 'Eligibility Reminder', subject: "You moved out of your plan's service area - you may be eligible for a Special Enrollment Period.", read: true },
  { id: '3', date: 'Jul 21, 2020', category: 'Coverage Change', subject: 'Your current plan no longer covers one of your prescriptions.', read: true },
  { id: '4', date: 'Jun 20, 2020', category: 'New Claim', subject: 'You have a new claim from Dr. Sarah Doe.', read: true }
]

export default messages
